module.exports = __webpack_public_path__ + "static/media/phasetwoinactive.06990ea2.png";